<template>
    <main class="main-content main-agenda main-agenda-interna">
        <div class="container-fluid container-agenda --orange">
            <div class="row">
                <div class="col-12">
                    <p class="agenda-title"><strong>AGENDA CULTURAL</strong></p>
                </div>
            </div>
        </div>

        <div class="container container-banner">
            <div class="row">
                <div class="col-12">
                    <div id='div-gpt-ad-1603501550614-0'></div>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-12 movie-schedule-container">
                    <div class="movie-schedule">
                        <div class="movie-schedule__calendar">
                            <div 
                                v-for="(date, key) in dates" :key="key"
                                data-id="1" 
                                :class="{
                                    'movie-schedule__calendar--item':true, 
                                    'active': date.getTime()==active_tab
                                }"
                                @click="active_tab=date.getTime()">
                                <p>{{weekdays[date.getDay()]}}</p>
                                <p>{{date.getDate()}}</p>
                                <p>Maio</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container" v-if="events">
            <div class="row container-diary-cultural">
                <div class="col-12 col-lg-8">
                    <div 
                        class="date-elements active">
                        <template v-for="(event, event_key) in filteredEvents">
                            <div 
                                class="row row-container" 
                                :key="event_key">
                                <div class="col-12">
                                    <router-link :to="event.url" target="_self" class="schedule-item row">
                                        <div class="schedule__image schedule__image--agenda col-sm-12 col-md-6">
                                            <figure v-if="event.image">
                                                <img :src="utils.image(event.image, 448, 200)" alt="">
                                            </figure>
                                            <div class="schedule-date">
                                                <span>{{new Date(active_tab).getDate()}}</span>
                                                <span>{{new Date(active_tab).toLocaleDateString('pt-BR',{month:'long'})}}</span>
                                            </div>
                                        </div>
                                        <div class="schedule__infos col-sm-12 col-md-6">
                                            <div class="schedule__title">
                                                <p>{{event.title}}</p>
                                            </div>
                                            <div class="schedule__location">
                                                <p>{{event.start_time.substring(0,5)}} - {{event.end_time.substring(0,5)}}</p>
                                                <p>{{event.address}}</p>
                                            </div>
                                            <div class="schedule__content" v-if="event.content_preview">
                                                <p>{{event.content_preview.substring(0,80)}}</p>
                                            </div>
                                            <div class="schedule__btn-action">
                                                <p>Saiba mais</p>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                        </template>
                    </div>
                    
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import api from '@/api'
import utils from '@/utils'

export default {
    name: 'Agenda',
    head:{
        title: {
            inner: 'Agenda Cultural'
        }
    },
    data: function () {
        return {
            today: null,
            end: null,
            utils:utils,
            events: null,
            dates: null,
            active_tab: null,
            weekdays: ['Domingo','Segunda','Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
        }
    },
    computed:{
        filteredEvents() {
            return this.events.filter(event =>{
                const dt_start = new Date(event.start_date.replace(/-/g,'/'))
                const dt_end = new Date(event.end_date.replace(/-/g,'/'))

                if (this.active_tab === dt_start.getTime() || this.active_tab === dt_end.getTime()){
                    return true
                } else if (dt_start.getTime() <= this.active_tab && dt_end.getTime() >= this.active_tab) {
                    return true
                }
                return false
            })
        }
    },
    methods: {
        getDates (startDate, endDate) {
            var dates = [],
                currentDate = startDate
            while (currentDate <= endDate) {
                dates.push(currentDate);
                currentDate = this.addDays(currentDate, 1);
            }
            return dates;
        },
        addDays(date, days) {
            var result = new Date(date);
            result.setDate(result.getDate() + days);
            return result;
        },
        async getEvents() {
            this.today = new Date(new Date().getFullYear(),new Date().getMonth() , new Date().getDate())
            this.end = this.addDays(this.today, 7)
            this.dates = this.getDates(this.today, this.end)
            this.active_tab = this.dates[0].getTime()

            const response = await api.get('events/', {
                fields: 'start_date,end_date,start_time,end_time,address,url,image,content_preview'
            })

            if (response.ok) {
                this.events = response.data.items
            }
        },
    },
    mounted() {
        this.getEvents()

        var googletag = window.googletag
        googletag.cmd.push(function() {
            googletag.destroySlots()
            googletag.defineSlot('/1513505/v1_gweb_superbanner_topo', [[970,250], [300, 100], [728, 90]], 'div-gpt-ad-1603501550614-0').addService(googletag.pubads());
            googletag.pubads().enableSingleRequest();
            googletag.pubads().collapseEmptyDivs()
            googletag.enableServices();
            googletag.display('div-gpt-ad-1603501550614-0');
        })
    }
}
</script>